import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/shared/Header";
import Footer from "./components/shared/Footer";
import Contato from "./components/contato/Contato";
import Hero from "./components/hero/Hero";
import Produtos from "./components/produto/sliderProduto/SliderProduto";
import ModalCarrinho from './components/utils/ModalCarrinho';

import { ModalProvider } from "./services/context/ModalContext";
import Produto from "./components/produto/paginaProduto/PaginaProduto";
import ProdutosGrid from "./components/produto/gridProduto/GridProduto";
import Login from "./components/login/LoginOrCreateAccount";
import Perfil from "./components/perfil/Perfil";
import Portfolio from "./components/portfolio/Portfolio";
import Checkout from "./components/checkout/Checkout";
import { AuthProvider } from "./services/context/AuthContext";
import { CarrinhoProvider } from "./services/context/CarrinhoContext";
import AutorBiografia from "./components/autor/AutorBiografia";

import "./App.css";
import "./assets/styles/Reset.css";

function App() {
  const main = process.env.REACT_APP_MAIN;

  return (
    <AuthProvider>
      <CarrinhoProvider>
        <ModalProvider>
          <Router>
            <div className="App">
              <Header />

              <Routes>
                <Route
                  path={main}
                  element={
                    <>
                      <Hero /> <Produtos nome={"Mais Populares"} />{" "}
                      <Produtos
                        nome={"Mais Recentes"}
                        btn={true}
                        tipo={"recentes"}
                      />{" "}
                      <Portfolio /> <Contato />
                    </>
                  }
                ></Route>

                <Route path={main + "checkout/"} element={<Checkout />} />

                <Route path={main + "login/"} element={<Login />} />

                <Route path={main + "perfil/"} element={<Perfil />} />

                <Route path={main + "checkout/"} element={<Checkout />} />

                <Route path={main + "livros"} element={<ProdutosGrid />} />

                <Route path={main + "livros/:id"} element={<Produto />} />

                <Route path={main + "autores/:id"} element={<AutorBiografia />} />
              
                <Route path={main + "contato"} element={<Contato />} />
              </Routes>

              <a
                href="https://wa.link/o4jzw4"
                alt="whatsapp link"
                target="_blank"
                rel="noreferrer"
              >
                <i className="uil uil-whatsapp whats-btn"></i>
              </a>
              <ModalCarrinho />


              <Footer />
            </div>
          </Router>
        </ModalProvider>
      </CarrinhoProvider>
    </AuthProvider>
  );
}

export default App;
